import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
const HERO_BG = 'https://cdn.magicpatterns.com/uploads/6ZAynorNPQnLfz6RriyKNX/vitaly-gariev-XV27HoZzYK8-unsplash.jpg';
export function Hero() {
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-20%', '20%']);
  return <section ref={ref} className="relative overflow-hidden w-full min-h-[100svh] pt-[60px] md:pt-[64px] flex items-center" data-id="element-87">
      {/* Background image */}
      <motion.div style={{
      y,
      backgroundImage: `url(${HERO_BG})`
    }} className="absolute inset-[-20%] z-0 bg-cover bg-center grayscale" data-id="element-88" />

      {/* Overlays — siblings of the bg, cover the full section */}
      <div className="absolute inset-0 z-10 bg-brand-black/50" data-id="element-89" />
      <div className="absolute inset-0 z-10 bg-gradient-to-r from-brand-black via-brand-black/80 to-transparent" data-id="element-90" />
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-brand-black/70 via-transparent to-transparent" data-id="element-91" />
      <div className="absolute inset-0 z-10 film-grain pointer-events-none" data-id="element-92" />

      {/* Content */}
      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-[120px] md:py-[160px] flex flex-col items-start text-left" data-id="element-93">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-brand-lime font-mono tracking-widest uppercase text-sm md:text-base mb-6" data-id="element-94">
          Serving Communities Since 2009
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-brand-soft text-[44px] md:text-[80px] lg:text-[100px] leading-[0.9] font-display mb-8 max-w-4xl uppercase" data-id="element-95">
          <span className="text-brand-lime" data-id="element-96">Free</span> Essentials.
          <br data-id="element-97" />
          Real Connection.
          <br data-id="element-98" />
          Built for the People.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-brand-soft/80 text-base md:text-lg max-w-[600px] mb-10 leading-relaxed font-sans" data-id="element-99">
          Free phones, free tablets, free home internet, and free healthcare
          insurance for qualifying households. Prime Nation connects you to
          government-assisted resources you already qualify for.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-100">
          <button className="w-full sm:w-auto bg-brand-lime text-brand-black px-8 py-4 font-mono font-bold text-sm uppercase tracking-widest hover:bg-white transition-colors min-h-[52px] flex items-center justify-center" data-id="element-101">
            See If You Qualify
          </button>
          <button className="w-full sm:w-auto bg-transparent border-2 border-brand-concrete text-brand-soft px-8 py-4 font-mono font-bold text-sm uppercase tracking-widest hover:border-brand-lime hover:text-brand-lime transition-colors min-h-[52px] flex items-center justify-center" data-id="element-102">
            Browse Services
          </button>
        </motion.div>
      </div>
    </section>;
}